export default {"src":"/_next/static/media/location_icon.45dcd2dc.svg","height":24,"width":18,"blurWidth":0,"blurHeight":0};